<!-- 公告列表 -->
<template>
  <div id="news" class="dashboard-container">
    <div class="nav">
      <el-input
        clearable
        placeholder="输入您想查找的关键词"
        @change="onSearch"
        v-model="q"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <div class="list">
      <div
        class="item"
        v-for="item in list"
        :key="item.id"
        @click="onDetail(item)"
      >
        <div class="item-l">
          <el-image
            v-if="item.cover"
            style="width: 31rem; height: 13rem; border-radius: 0.4rem"
            :src="item.cover"
            :fit="fill"
          ></el-image>
        </div>
        <div class="item-r">
          <div class="item-r-t">
            <div class="item-r-t-title">{{ item.title }}</div>
            <div class="item-r-t-content"></div>
          </div>
          <div class="item-r-b">
            {{ item.addtime }}
          </div>
        </div>
      </div>
    </div>
    <pagination
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      :page-sizes="[10,20,50,100]"
      @pagination="getNotice"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import qs from "qs";
export default {
  data() {
    return {
      q: "",
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },

  components: {
    Pagination,
  },

  computed: {},
  async mounted() {
    this.getNotice();
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.getNotice();
  },
  methods: {
    onSearch() {
      this.getNotice();
    },
    onDetail(val) {
      this.$router.push({
        name: "dataTotaladd",
        query: {
          id:val.id,
        },
      });
    },
    async getNotice() {
      this.axios
        .post(
          "/api/notice/lookNotice",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            scope: "3",
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
            title: this.q,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.list = res.data.data.data;
          this.total = res.data.data.total;
        })
        .catch(function (err) {});
    },
  },
};
</script>
<style lang='scss' scoped>
.dashboard {
  &-container {
    margin: 3rem;
  }
  &-text {
    font-size: 3rem;
    line-height: 4.6rem;
  }
}
#news {
  width: 96%;
}
.nav {
  font-size: 2.3rem;
  text-align: center;
}
.list {
  margin-top: 2rem;
  font-size: 1.8rem;
}

.item {
  display: flex;
  background-color: #fff;
  margin: 1.2rem 0;
  padding: 1.2rem 1rem;
  cursor: pointer;
}
.item {
  &-l {
    margin-right: 3.1rem;
  }
  &-r {
    width: 93.3rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &-t {
      &-title {
        width: 93.3rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #0078E6;
        font-size: 2rem;
        font-weight: bold;
      }
      &-content {
        margin-top: 1rem;
        width: 93.3rem;
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        color: #444;
        line-height: 2.6rem;
      }
    }
    &-b {
      margin-top: 3.6rem;
      color: #888;
      font-size: 1.4rem;
    }
  }
}
</style>
<style>
#news .item-r-t-content div,
#news .item-r-t-content p,
#news .item-r-t-content span {
  font-size: 1.4rem !important;
  font-family: 微软雅黑 !important;
}
</style>